var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61421 14.0354H13.2354C14.4238 14.0354 15.1646 12.7467 14.5704 11.7204L8.7598 1.68111C8.16562 0.654799 6.68403 0.654799 6.08985 1.68111L0.279231 11.7204C-0.314949 12.7467 0.425847 14.0354 1.61421 14.0354ZM7.42482 8.63379C7.00041 8.63379 6.65316 8.28654 6.65316 7.86213V6.3188C6.65316 5.89439 7.00041 5.54714 7.42482 5.54714C7.84924 5.54714 8.19649 5.89439 8.19649 6.3188V7.86213C8.19649 8.28654 7.84924 8.63379 7.42482 8.63379ZM8.19649 11.7204H6.65316V10.1771H8.19649V11.7204Z",
    fill: "#1B51A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert_icon.587f4e8294a0427d8c3e14b5867afd53.svg";
export { ForwardRef as ReactComponent };